import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { setsSummary } from "./helpers";

export function TVMode({ matchday, standings, playersMap, onClose }) {
  const courts = matchday ? matchday.matches.slice().sort((a, b) => a.court - b.court) : [];
  const slides = [...courts.map((c) => ({ type: "court", data: c })), { type: "standings" }];
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % slides.length), 6000);
    return () => clearInterval(t);
  }, [slides.length]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const slide = slides[idx];
  const names = (ids) => ids.map((id) => playersMap[id]?.short_name).join(" / ");

  return (
    <div
      className="fixed inset-0 z-[100] bg-[#060a12] flex flex-col items-center justify-center"
      data-testid="tv-mode-overlay"
    >
      <button
        data-testid="tv-mode-close"
        onClick={onClose}
        className="absolute top-6 right-6 z-[120] w-11 h-11 rounded-full bg-slate-800/80 hover:bg-slate-700 flex items-center justify-center text-slate-300"
      >
        <X className="w-5 h-5" />
      </button>

      <div className="absolute top-8 left-0 right-0 text-center">
        <div className="font-mono text-emerald-400 tracking-[0.4em] text-sm">AMERICAN PADEL 2026</div>
        {matchday && (
          <div className="font-display uppercase text-slate-500 tracking-widest text-xs mt-1">
            Giornata {matchday.number}
          </div>
        )}
      </div>

      <div className="w-full max-w-5xl px-8 ap-rise" key={idx}>
        {slide?.type === "court" ? (
          <div className="text-center">
            <div className="font-display font-black uppercase text-emerald-400 text-3xl tracking-wide mb-10">
              Campo {slide.data.court} · {slide.data.time}
            </div>
            {(() => {
              const sets = slide.data.sets || [];
              const s1 = sets.filter((s) => s.g1 > s.g2).length;
              const s2 = sets.filter((s) => s.g2 > s.g1).length;
              const done = slide.data.status === "completed";
              return (
                <div className="space-y-6">
                  <div className="flex items-center justify-between gap-8">
                    <span className={`font-display font-bold uppercase text-4xl ${done && s1 > s2 ? "text-white" : "text-slate-400"}`}>
                      {names(slide.data.team1)}
                    </span>
                    <span className="font-mono font-black text-7xl text-emerald-400">{done ? s1 : "–"}</span>
                  </div>
                  <div className="h-px bg-slate-800" />
                  <div className="flex items-center justify-between gap-8">
                    <span className={`font-display font-bold uppercase text-4xl ${done && s2 > s1 ? "text-white" : "text-slate-400"}`}>
                      {names(slide.data.team2)}
                    </span>
                    <span className="font-mono font-black text-7xl text-emerald-400">{done ? s2 : "–"}</span>
                  </div>
                  <div className="font-mono text-slate-500 text-lg pt-4">
                    {done ? setsSummary(sets) : "In programma"}
                  </div>
                </div>
              );
            })()}
          </div>
        ) : (
          <div>
            <div className="font-display font-black uppercase text-amber-400 text-3xl tracking-wide mb-8 text-center">
              Classifica
            </div>
            <div className="space-y-2">
              {standings.slice(0, 6).map((p) => (
                <div
                  key={p.player_id}
                  className="flex items-center justify-between px-6 py-3 rounded-xl bg-slate-900/70 border border-slate-800"
                >
                  <div className="flex items-center gap-4">
                    <span className="font-display font-black text-2xl text-slate-400 w-8">{p.position}</span>
                    <span className="font-display font-bold uppercase text-2xl text-white">{p.name}</span>
                  </div>
                  <span className="font-mono font-black text-3xl text-emerald-400">{p.points}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="absolute bottom-8 flex gap-2">
        {slides.map((_, i) => (
          <span
            key={i}
            className={`h-1.5 rounded-full transition-all ${i === idx ? "w-8 bg-emerald-400" : "w-1.5 bg-slate-700"}`}
          />
        ))}
      </div>
    </div>
  );
}
